var MenuComponent = /** @class */ (function () {
    function MenuComponent() {
        this.name = "aqui";
    }
    return MenuComponent;
}());
export { MenuComponent };
